import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

// import { LocationDataCollectionSummaryRepository } from '../data/contracts/location-data-collection-summary.repository';
// import { LocationInspectionSummaryRepository } from '../data/contracts/location-inspection-summary.repository';
// import { LocationMetricPairWidgetsRepository } from '../data/contracts/location-metric-pair-widgets.repository';
// import { LocationLoadRepository } from '../data/contracts/location-load.repository';
// import { LocationRobotReadRepository } from '../data/contracts/location-robot-read.repository';
import { LocationRepository } from '@core/data/location/location.repository';
// import { SiteWeatherRepository } from '../data/contracts/site-weather.repository';
// import { MockLocationDataCollectionSummaryRepository } from '../data/mock/mock-location-data-collection-summary.repository';
// import { MockLocationInspectionSummaryRepository } from '../data/mock/mock-location-inspection-summary.repository';
// import { MockLocationMetricPairWidgetsRepository } from '../data/mock/mock-location-metric-pair-widgets.repository';
// import { MockLocationLoadRepository } from '../data/mock/mock-location-load.repository';
// import { MockLocationRepository } from '../data/mock/mock-location.repository';
// import { MockLocationRobotReadRepository } from '../data/mock/mock-location-robot-read.repository';
// import { MockSiteRepository } from '../data/mock/mock-site.repository';
// import { MockSiteWeatherRepository } from '../data/mock/mock-site-weather.repository';
// import { environment } from 'src/environments/environment';
import { SiteRepositoryHttp } from '@core/data/site/site.repository.http';
import { LocationRepositoryHttp } from '@core/data/location/location.repository.http';
import { SiteFacade } from '@core/data/site/site-facade';
import { SiteRepository } from '@core/data/site/site.repository';
import { InspectionRepositoryHttp } from '@core/data/inspections/inspection.repository.html';
import { InspectionMediaRepositoryHttp } from '@core/data/inspection-media/media.repository.html';
import { InspectionMediaFacade } from '@features/sites/locations/location-dashboard/facades/inspection-media-facade';
import { SiteDashboardFacade } from '@features/sites/site-dashboard/site-dashboard.facade';
import { InspectionFacade } from '@core/data/inspections/inspection.facade';
import { LocationFacade } from '@core/data/location/location-facade';
import { RobotRepositoryHttp } from '@core/data/robot/robot.repository';
import { AlertsFacade } from '@core/data/alerts/alerts.facade';
import { AlertsRepositoryHttp } from '@core/data/alerts/alerts.repository';
import { EnvironmentalDataFacade } from '@features/sites/locations/location-dashboard/facades/environmental.facade';
import { EnvironmentalRepositoryHttp } from '@core/data/environment-data/environmental.repository.http';
import { OcuRepositoryHttp } from '@core/data/ocu/ocu.repository';

export function provideAppShellData(): EnvironmentProviders {
  // if (environment.enableMocks) {
  //   return makeEnvironmentProviders([
  //     MockLocationRepository,
  //     MockLocationDataCollectionSummaryRepository,
  //     MockLocationInspectionSummaryRepository,
  //     MockLocationMetricPairWidgetsRepository,
  //     MockLocationLoadRepository,
  //     MockLocationRobotReadRepository,
  //     MockSiteRepository,
  //     MockSiteWeatherRepository,
  //     {
  //       provide: LocationRepository,
  //       useExisting: MockLocationRepository,
  //     },
  //     {
  //       provide: LocationDataCollectionSummaryRepository,
  //       useExisting: MockLocationDataCollectionSummaryRepository,
  //     },
  //     {
  //       provide: LocationInspectionSummaryRepository,
  //       useExisting: MockLocationInspectionSummaryRepository,
  //     },
  //     {
  //       provide: LocationMetricPairWidgetsRepository,
  //       useExisting: MockLocationMetricPairWidgetsRepository,
  //     },
  //     {
  //       provide: LocationLoadRepository,
  //       useExisting: MockLocationLoadRepository,
  //     },
  //     {
  //       provide: LocationRobotReadRepository,
  //       useExisting: MockLocationRobotReadRepository,
  //     },
  //     {
  //       provide: SiteRepository,
  //       useExisting: MockSiteRepository,
  //     },
  //     {
  //       provide: SiteWeatherRepository,
  //       useExisting: MockSiteWeatherRepository,
  //     },
  //   ]);
  // }

  return makeEnvironmentProviders([
    SiteRepositoryHttp,
    SiteDashboardFacade,
    SiteFacade,
    LocationRepositoryHttp,
    InspectionRepositoryHttp,
    InspectionMediaRepositoryHttp,
    InspectionMediaFacade,
    InspectionFacade,
    LocationFacade,
    AlertsFacade,
    AlertsRepositoryHttp,
    EnvironmentalDataFacade,
    EnvironmentalRepositoryHttp,
    RobotRepositoryHttp,
    OcuRepositoryHttp,
    {
      provide: SiteRepository,
      useExisting: SiteRepositoryHttp,
    },
    {
      provide: LocationRepository,
      useExisting: LocationRepositoryHttp,
    },
  ]);
}
